var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/* eslint-disable */
/* tslint:disable */
import * as React from 'react';
var WcWomen = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24" }, props),
        React.createElement("path", { d: "M14.2192236,9 C14.6780912,9 15.0780743,9.31229737 15.1893661,9.75746437 L17,17 L14,17 L14,21 L11,21 L11,17 L8,17 L9.81063391,9.75746437 C9.92192566,9.31229737 10.3219088,9 10.7807764,9 L14.2192236,9 Z M14.2192236,10 L10.7807764,10 L9.28,16 L12,16 L12,20 L13,20 L13,16 L15.719,16 L14.2192236,10 Z M12.5,4 C13.8807119,4 15,5.11928813 15,6.5 C15,7.88071187 13.8807119,9 12.5,9 C11.1192881,9 10,7.88071187 10,6.5 C10,5.11928813 11.1192881,4 12.5,4 Z M12.5,5 C11.6715729,5 11,5.67157288 11,6.5 C11,7.32842712 11.6715729,8 12.5,8 C13.3284271,8 14,7.32842712 14,6.5 C14,5.67157288 13.3284271,5 12.5,5 Z" })));
};
WcWomen.displayName = 'WcWomen';
export default WcWomen;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=WcWomen.js.map